import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white py-8 sm:py-20" data-id="element-161">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-slate-50 rounded-xl sm:rounded-3xl p-5 sm:p-12 text-center ring-1 ring-slate-200 shadow-sm relative overflow-hidden" data-id="element-163">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 sm:w-64 sm:h-64 bg-blue-100 rounded-full blur-3xl opacity-50 -z-10" data-id="element-164"></div>

          <div className="mx-auto w-10 h-10 sm:w-16 sm:h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-3 sm:mb-6" data-id="element-165">
            <ShieldCheck className="w-5 h-5 sm:w-8 sm:h-8" data-id="element-166" />
          </div>

          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-blue-600 uppercase mb-1.5 sm:mb-3" data-id="element-167">
            7 DÍAS GARANTÍA TOTAL
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-3xl mb-1.5 sm:mb-4" data-id="element-168">
            Probalo o te devolvemos el 100%
          </p>
          <p className="text-[10px] sm:text-lg text-slate-600" data-id="element-169">
            Sin preguntas, sin formularios, sin drama.
          </p>
        </motion.div>
      </div>
    </section>;
}